import { useAuth } from '@/entities/user';

export const useLoadingIntro = () => {
  const { value: user, fetching } = useAuth((s) => s.signedInUser);

  return {
    fetching,
    userName: user?.name.split(' ')[0],
  };
};
